var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"pageLayout",staticClass:"widget flex"},_vm._l((_vm.pages),function(p){return _c('div',{key:p.pageNumber,class:[
        'widget-page text-center pr-2 mt-1',
        p.pageNumber > 1
          ? _vm.isMobileLayout
            ? 'ml-4 pl-2'
            : 'ml-6 pl-2'
          : 'ml-2',
        p.isSelected ? 'widget-page__selected' : '',
        _vm.isMobileLayout ? 'widget-page__mobile pt-3' : 'pt-5' ],on:{"click":function($event){return _vm.onPageClick(p.pageNumber)}}},[_vm._v(" "+_vm._s(p.pageNumber)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }